import React, { useEffect } from 'react';
import { GreyStrokeInfoIcon } from 'assets/icons';
import { useLazyGetPayoutScheduleQuery } from 'containers/payouts/api';
import { Loader } from 'components';

const PayoutScheduleTable = () => {
  const [getPaymentSchedule, { data: scheduleData, isFetching }] = useLazyGetPayoutScheduleQuery();

  useEffect(() => {
    getPaymentSchedule();
  }, [getPaymentSchedule]);

  if (isFetching) {
    return <Loader />;
  }

  if (!scheduleData) {
    return null;
  }

  const { headingA, headingB, web } = scheduleData.Data ?? {};

  if (!headingA || !headingB || !web) {
    return null;
  }

  return (
    <div className="flex w-full flex-col gap-4">
      <div className="flex flex-col gap-2.5">
        <div className="text-sbase font-semibold text-primaryText">{headingA}</div>
        <div className="text-sbase font-normal text-primaryText">{headingB}</div>
      </div>

      <div className="w-full overflow-x-auto">
        <div className="w-full rounded-lg border border-borderGray p-5 2xl:max-w-[854px]">
          {/* Table Header */}
          <div className="grid grid-cols-4 gap-6 border-b border-borderGray pb-4">
            <div className="text-17px font-bold text-primaryText">Payments collected on</div>
            <div className="text-17px font-bold text-primaryText">Close of day (ET)</div>
            <div className="text-17px font-bold text-primaryText">Payout created and sent</div>
            <div className="text-17px font-bold text-primaryText">Arrives in Bank</div>
          </div>

          {/* Table Body */}
          <div>
            {web.map((item, index) => (
              <div
                key={index}
                className={`grid grid-cols-4 gap-6 py-4 ${
                  index !== web.length - 1 ? 'border-b border-borderGray' : ''
                }`}>
                <div className="text-17px font-medium text-primaryText">{item.collectedOn}</div>
                <div className="text-17px font-medium text-primaryText">{item.closeOfDay}</div>
                <div className="whitespace-pre-line text-17px font-medium text-primaryText">{item.payoutCreatedOn}</div>
                <div className="text-17px font-medium text-primaryText">{item.arrivesInBank}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Holiday Information */}
      <div
        className="flex w-full items-start gap-3 rounded-lg border
       border-secondary bg-[#A4D7FA80] px-4 py-3 2xl:max-w-[854px]">
        <GreyStrokeInfoIcon className="path-fill-current mt-0.5 h-5 w-5 shrink-0 text-secondary" />
        <div className="flex flex-col gap-1">
          <div className="text-sbase font-semibold text-primaryText">Bank holidays may delay payouts.</div>
          <div className="text-sbase font-normal text-primaryText">
            This schedule shows a normal week without holidays.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayoutScheduleTable;
